import OurMissionHeader from './OurMissionHeader'
import LawTech from './law-tech/LawTech'
import OurSponsors from './OurSponsors'
import BuildTrust from './BuildTrust'
const OurMission = () => {
  return (
    <>
      <OurMissionHeader />
      <LawTech />
      <OurSponsors />
      <BuildTrust />
    </>
  )
}

export default OurMission
